import { Injectable } from '@angular/core';
import { TREQUEST_TNA_BOARD_FILTERS, TREQUEST_TNA_BOARD_LISTING } from '@monorepo/types';
import { Store, select } from '@ngrx/store';
import { TPlani8State } from '../reducers';
import { GetTnaBoardList } from './tna-board.actions';
import * as TnaBoardSelector from './tna-board.selectors';
import { AppNotificationUtilClass, Plani8DataService } from '@monorepo/services';
import { switchMap, finalize } from 'rxjs/operators';
import { from, lastValueFrom } from 'rxjs';

export const TNA_BOARD_ITEMS_PER_PAGE_LIST = [10, 50, 100, 200];
@Injectable({
  providedIn: 'root',
})
export class TnaBoardFacade {
  constructor(
    private store: Store<TPlani8State>,
    private plani8DataService: Plani8DataService,
    private appNotificationUtilClass: AppNotificationUtilClass,
  ) {}

  fetchTnaBoardList(payload: TREQUEST_TNA_BOARD_LISTING) {
    console.log('[HTTP] Fetch Tna Board List', payload);
    this.store.dispatch(new GetTnaBoardList(payload));
  }
  getTnaBoardList() {
    return this.store.pipe(select(TnaBoardSelector.GetTnaBoardListStore));
  }

  async getTnaBoardFilters(payload: TREQUEST_TNA_BOARD_FILTERS) {
    const loading = await this.appNotificationUtilClass.presentLoading('Loading Filters...', 3000);
    return lastValueFrom(this.plani8DataService.getTnaBoardFilters(payload)).finally(() => {
      loading.dismiss();
    });
  }

  async getTnaBoardOderInfoById(orderId: string) {
    const loading = await this.appNotificationUtilClass.presentLoading('Loading Order Details', 3000);
    return lastValueFrom(this.plani8DataService.getTnaBoardOrderInfo(orderId)).finally(() => {
      this.appNotificationUtilClass.dismissLoadingV2(loading);
    });
  }

  async getTnaBoardOrderProgressById(orderId: string) {
    const loading = await this.appNotificationUtilClass.presentLoading('Loading Order Details', 3000);
    return lastValueFrom(this.plani8DataService.getTnaBoardOrderProgress(orderId)).finally(() => {
      this.appNotificationUtilClass.dismissLoadingV2(loading);
    });
  }

  async getMaterialInHouseByOtl(otlId: string) {
    const loading = await this.appNotificationUtilClass.presentLoading('Loading', 3000);
    return lastValueFrom(this.plani8DataService.getMaterialInHouseByOtl(otlId)).finally(() => {
      this.appNotificationUtilClass.dismissLoadingV2(loading);
    });
  }
}

export type TGetTnaBoardList = ReturnType<TnaBoardFacade['getTnaBoardList']>;
export type TGetTnaBoardOrderInfo = ReturnType<TnaBoardFacade['getTnaBoardOderInfoById']>;
export type TGetTnaBoardOrderProgressInfo = ReturnType<TnaBoardFacade['getTnaBoardOrderProgressById']>;
export type TGetTnaBoardFilters = ReturnType<TnaBoardFacade['getTnaBoardFilters']>;
